import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal, TemplateRef } from '@angular/core';

@Component({
	selector: 'tooltip-message',
	template: `
		<div
			class="py-0.5 px-1 rounded-0.75 text-m text-190 bg-fg-800 flex items-start justify-start whitespace-nowrap"
			animate.enter="tooltip-fade-in"
		>
			@if ($isString()) {
				{{ $message() }}
			} @else {
				<ng-container
					[ngTemplateOutlet]="$outlet()"
					[ngTemplateOutletContext]="$context()"
				></ng-container>
			}
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule],
	styles: [
		`
			.tooltip-fade-in {
				animation: tooltipFadeIn 150ms ease-out forwards;
			}

			@keyframes tooltipFadeIn {
				from {
					opacity: 0;
				}

				to {
					opacity: 1;
				}
			}
		`,
	],
})
export class TooltipMessageComponent {
	public readonly $message = signal<string | TemplateRef<unknown> | null>(null);
	public readonly $context = signal<Record<string, unknown>>({});

	public readonly $isString = computed(() => {
		const message = this.$message();
		return typeof message === 'string';
	});

	public readonly $outlet = computed(() => {
		const message = this.$message();
		return typeof message === 'string' ? null : message;
	});

	public setMessage(
		message: string | TemplateRef<void> | null,
		context: Record<string, unknown>
	) {
		this.$message.set(message);
		this.$context.set(context);
	}
}
